<template lang="html">
	<div>
		<vs-card>
			<div slot="header">
				<vs-row>
					<vs-col vs-w='9'>
						<h3>{{ $t('Edit') }}</h3>
					</vs-col>
					<vs-col vs-w='3'>
						<vs-button @click.prevent='importDialog=true'>{{$t('Import')}}</vs-button>
						<vs-button @click.prevent='exportJson()' class='ml-1'>{{$t('Export')}}</vs-button>
					</vs-col>
				</vs-row>
			</div>
		</vs-card>

		<vs-card>
			<div slot="header">
				<vs-row  class='text-base'>
					<vs-col vs-w='12'>
						<label class="w-full">{{ $t('Language') }}:</label>
						<vs-select v-model='form.language_code' class='w-full'>
							<vs-select-item :key='language.code' v-for='language in languages' :value='language.code' :text='language.title' />
						</vs-select>
					</vs-col>
				</vs-row>
			</div>
		</vs-card>

		<vs-card>
			<div slot="header">
				<vs-row  class='text-base'>
					<vs-col vs-w='9'>
						{{ $t('ShowOnlyMissingTranslation') }}
					</vs-col>
					<vs-col vs-w='3'>
						<vs-switch class='float-right' v-model='onlyMissing'></vs-switch>
					</vs-col>
				</vs-row>
			</div>
		</vs-card>

		<vs-card>
			<div>
				<vs-row>
					<vs-col vs-w='12'>
						<vs-table search max-items="10" pagination :data="translations">
							<template slot='thead'>
								<vs-th sort-key='key'>Keys</vs-th>
								<vs-th sort-key='value'>Values</vs-th>
							</template>
							<template slot-scope="{data}">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<vs-td>{{ tr.key }}</vs-td>
									<vs-td>
										<vs-input v-model='tr.value' />
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</vs-col>
				</vs-row>
				<vs-row>
					<vs-col vs-w='2'>
						<vs-button @click.prevent='submit()' color='success'>Save</vs-button>
					</vs-col>
					<vs-col vs-w='2'>
						<vs-button @click.prevent='reset()' color='warning'>Reset</vs-button>
					</vs-col>
				</vs-row>
			</div>
		</vs-card>
    <vs-prompt :title="$t('Import')" class="export-options" @cancel="$refs.fileJson.files = []" :isValid="fields.locale_import_file && !fields.locale_import_file.invalid" @accept="importJson()" :accept-text="$t('Import')" @close="$refs.fileJson.files = []" :active.sync="importDialog">
      <input type='file' @blur="$validator.validate('locale_import_file')" v-validate="'required|ext:json|import_file_check'" name='locale_import_file' ref='fileJson' class='w-full' accept='json/*' />
			<span class="text-danger" v-if="errors.has('locale_import_file')">{{ errors.first('locale_import_file')}}</span>
	</vs-prompt>
	</div>

</template>

<script>
import { getLanguages, getAdminTranslations, updateAdminTranslations, getTranslations } from '../../../api/locale'
import vSelect from 'vue-select'
import { Validator } from "vee-validate";

const importhandler = (file) => new Promise((resolve, reject) => {
	const fr = new FileReader();
	fr.onload = function (event) {
		try {
			const translations = JSON.parse(event.target.result);
			resolve(translations);
		}catch(err) {
			console.log(err);
			reject(err);
		}
	}
	console.log('importhandler:file',file);
	fr.readAsText(file);
});

export default {
	data() {
		return {
			importDialog: false,
			onlyMissing: false,
			form: {
				language_code: null,
				translations: [],
				missing: [],
			},
			languages: [],
			fileJson: null
		}
	},
	computed: {
		isValidFormImport() {
			return !this.errors.has('locale_import_file') && this.$refs.fileJson && this.$refs.fileJson.files.length > 0
		},
		translations() {
			return this.form.translations.filter(t => t.isMissing === this.onlyMissing);
		}
	},
	components: { vSelect },
	async created() {
		this.form.language_code = this.$route.params.code;
		this.$vs.loading();
		await Promise.all([this.getAll(), this.getAllTranslations()]);
		this.$vs.loading.close();
	},
	mounted() {
		const fileCheck = async (files) => {
			try{
				await importhandler(files[0])
				return {valid:true}
			}catch(err){
				return {valid: false}
			}
		};
		Validator.extend('import_file_check', {
			validate: fileCheck
		});
	},
	watch: {
		'form.language_code': function(language_code, old) {
			if(old){
				this.$router.push({ name:'LanguageEdit', params: {code:language_code}})
				this.getAllTranslations()
			}
		},
		onlyMissing: function(missing) {
			this.reset();
		}
	},
	methods: {
		async getAll() {
			try{
				const res = await getLanguages();
				if(res.status==200 && res.data.status=='success') {
					this.languages = res.data.data;
				}else
				throw res.data.message
			}catch(err){
				this.$log.error('File : languages/Edit.vue | Function : getAll() | Error :', err);
				this.$vs.notify({
					title: this.$t('Error'),
					text: err,
					color: "danger",
					position: "top-center"
				});
				console.error(err);
			}
		},
		mapToForm(translations) {
			this.form.translations = translations.map(t => (
				{
					key:t.key,
					value:t.value ? t.value : '',
					old:t.value ? t.value : '',
					isMissing: Boolean(t.isMissing)
				}
			));
			console.log('translations', this.form.translations);
		},
		async getAllTranslations() {
			try{
				const res = await getAdminTranslations(this.form.language_code);
				console.log(res);
				if(res.status == 200 && res.data.status=='success') {
					this.mapToForm([
						...res.data.data.available, 
						...res.data.data.missing.map(m => {
							m.isMissing = true;
							return m;
						})
					]);
				}else
					throw res.data.message
			}catch(err){
				this.$log.error('File : languages/Edit.vue | Function : getAllTranslations() | Error :', err);
				this.$vs.notify({
					title: this.$t('Error'),
					text: err,
					color: "danger",
					position: "top-center"
				});
				console.error(err);
			}
		},
		async saveToServer(payload) {
			this.$vs.loading()
			try{
				const res = await updateAdminTranslations(this.form.language_code, payload);
				if(res.status == 200 && res.data.status=='success') {
					this.getAllTranslations(); // refresh list
					this.$vs.notify({
						title: this.$t('Saved'),
						text: '',
						color: "success",
						position: "top-center"
					});
				}else
					throw res.data.message;
			}catch(err) {
				this.logError('submit', err, err);
				console.error(err);
			}
			this.$vs.loading.close();
		},

		submit() {
			const translations = this.form.translations.filter(t => t.isMissing == this.onlyMissing && t.old!=t.value);
			this.saveToServer({translations});
		},
		reset() {
			this.form.translations = this.form.translations.map(t => {
				t.value = t.old;
				return t;
			})
		},

		async exportJson () {
			try{
				const res = await getTranslations(this.form.language_code);
				if(res.data.status != 'success')
					throw res.data.message;
				console.log(res);
				const translations = res.data.data[`${this.form.language_code}`]['messages'];
				const blob = new Blob([JSON.stringify(translations, null, 2)],{type : 'application/json'});
				const url = URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.setAttribute('href', url);
				a.setAttribute('download', `${this.form.language_code}.json`);
				a.click();
				a.remove();
			}catch(err) {
				console.log(err);
				this.logError('exportJson', err);
			}	
		},
		async importJson() {
			const files = this.$refs.fileJson.files;
			const me = this;
			try{
				if(files.length < 1)
					throw 'Please select a file to import';
				const translations = await importhandler(files.item(0));
				const req = {refresh: true, translations: []};
				for(let prop in translations) {
					req.translations.push({key: prop, value:translations[prop]});
				}
				me.saveToServer(req);
			}catch(err) {
				console.error(err);
				this.logError('importJson', err, err);
			}
		},

		logError(functionName, error, textErr = null) {
			this.$log.error(`File : language/Edit.vue | Function : ${functionName}() | Error : `, error);
			this.$vs.notify({
				title: this.$t('Error'),
				color: "danger",
				text: textErr,
				position: "top-center"
			});
		}
	}


}
</script>

<style>

</style>